export enum AppConnectionType {

}
export enum AppType {
    Core = 'Core',
    Technadopt = 'Technadopt',
    ESP = 'ESP',
    SimpleStrata = 'Simple Strata',
    OppPro = 'OpportunityPro',
    CustomTab = 'custom tab',
    Higher = 'Higher',
    PowerBi = 'Power BI',
    Intajy = 'Intajy',
    TabOrder = 'tabOrder',
    AppAppearance = 'App Appearance',
    EngagementPro = 'Engpro',
    Office365 = 'Custom Meeting Scheduler',
    ChatBot = 'Chat Bot',
    GoogleAnalytics = 'GoogleAnalytics',
    VirtualRoom = 'Virtual Room',
    LeadLine = 'Lead Line',
    Tilda = 'Tilda',
    NotificationService = 'Notification Service',
    GlobalSearch = 'Global Search',
    ConnecteXeDedicationReport = 'Connectexe',
    Plannexe = 'Plannexe',
}

export enum ConnectAppDialogAction {
    ConnectApp = 'ConnectApp',
    SetOwnershipProcess = 'SetOwnershipProcess',
    ChangeLoginAccount = 'ChangeLoginAccoutn',
    ManageDashboards = 'ManageDashboards',
    ManageTeams = 'ManageTeams',
    DisconnectApp = 'DisconnectApp',
}